import {
  CreateWebhookT,
  Subscription,
  UpdateWebhookT,
} from 'lib-shared-legacy-types';
import { FormErrors } from 'redux-form';
import isURL from 'validator/lib/isURL';


import { FormValueProps } from './subscriptionForm';

export const validate = (values: FormValueProps): FormErrors => {
  const errors: Record<string, unknown> = {};

  if (!values) {
    return errors;
  }

  if (!values?.webhookName?.trim()) {
    errors.webhookName = 'Please add a title';
  }

  if (!values?.webhookUrl?.trim()) {
    errors.webhookUrl = 'Please add an url';
  } else if (
    !isURL(values.webhookUrl, {
      require_protocol: true,
      protocols: ['https'],
      require_valid_protocol: true,
    })
  ) {
    errors.webhookUrl = 'Please write a valid https URL';
  }

  if (!(values?.subscriptionEvents?.length > 0)) {
    errors.subscriptionEvents =
      'You need to pick at least one event to subscribe to this webhook';
  }

  return errors;
};

export const toFormValue = (subscription: Subscription): FormValueProps => ({
  id: subscription.id,
  webhookName: subscription.name,
  webhookUrl: subscription.url,
  subscriptionEvents: subscription.fqns,
  headers: subscription.user_supplied_headers,
  isEnabled: subscription.is_enabled,
});

export const toCreatePayload = ({
  webhookName,
  subscriptionEvents,
  webhookUrl,
  headers,
  isEnabled,
}: FormValueProps): CreateWebhookT => {
  return {
    name: webhookName,
    fqns: subscriptionEvents,
    url: webhookUrl,
    user_supplied_headers: headers || {},
    is_enabled: isEnabled || false,
  };
};

export const toUpdatePayload = (payload: FormValueProps): UpdateWebhookT => ({
  ...toCreatePayload(payload),
  id: payload.id as string,
});
